import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import MaintancesModal from '../MaintancesModal'
import RefuellingsModal from '../RefuellingsModal'
import { WhatsappLogo } from 'phosphor-react'

import { openWindow } from '../../../utils/whatsapp'

import styles from './styles.module.css'
import { useLoading } from '../../../hooks/LoadingContext'

function VehicleInfo({ vehicleId }) {
  const [vehicleInfo, setVehicleInfo] = useState({})

  const [showMaintancesModal, setShowMaintancesModal] = useState(false)
  const [showRefuellingsModal, setShowRefuellingsModal] = useState(false)

  const { setIsLoading } = useLoading()

  const handleCloseMaintancesModal = () => setShowMaintancesModal(false)
  const handleShowMaintancesModal = () => setShowMaintancesModal(true)

  const handleCloseRefuellingsModal = () => setShowRefuellingsModal(false)
  const handleShowRefuellingsModal = () => setShowRefuellingsModal(true)

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        const { data } = await api.get(`/company/vehicles/${vehicleId}?driverInfo=1`)
        setVehicleInfo(data)
      } catch (err) {
        toast.error('Falha ao buscar os dados do veículo. Tente novamente mais tarde')
      }
      setIsLoading(false)
    }
    loadData()
  }, [vehicleId, setIsLoading])

  return (
    <div className={`border ${styles.infosContainer}`}>
      <div style={{ marginLeft: 16, marginTop: 16 }}>
        <span className={styles.infoBoard}>{vehicleInfo.board}</span>
        <span className={styles.infoModelColor}>{vehicleInfo.model + ' ' + vehicleInfo.color}</span>
        <span
          className={styles.infooSpan}
          style={{
            marginTop: 13,
          }}
        >
          Capacidade:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {vehicleInfo.capacity} kg
          </span>
        </span>
        <span className={styles.infooSpan}>
          Motorista:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {vehicleInfo.driver_name ? vehicleInfo.driver_name : 'Desconhecido'}
          </span>
        </span>
        <span className={styles.infooSpan}>
          Contato:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {vehicleInfo.driver_phone ? vehicleInfo.driver_phone : 'Desconhecido'}
          </span>
        </span>
      </div>

      <div className="mt-2 d-flex justify-content-center">
        <Button
          className={styles.showModalBtn}
          style={{ marginRight: 10 }}
          onClick={handleShowRefuellingsModal}
        >
          Abastecimentos
        </Button>
        <Button className={styles.showModalBtn} onClick={handleShowMaintancesModal}>
          Manutenções
        </Button>
      </div>
      <div className="text-center mt-2 mb-3">
        <Button
          className={styles.contactDriverBtn}
          disabled={!vehicleInfo.driver_phone}
          onClick={() => openWindow(vehicleInfo.driver_phone)}
        >
          <WhatsappLogo style={{ marginRight: 3, marginTop: -3 }} size={20}></WhatsappLogo>
          Entrar em contato com o motorista
        </Button>
      </div>
      {showMaintancesModal && (
        <MaintancesModal
          show={showMaintancesModal}
          close={handleCloseMaintancesModal}
          vehicleId={vehicleId}
        ></MaintancesModal>
      )}
      {showRefuellingsModal && (
        <RefuellingsModal
          show={showRefuellingsModal}
          close={handleCloseRefuellingsModal}
          vehicleId={vehicleId}
        ></RefuellingsModal>
      )}
    </div>
  )
}

export default VehicleInfo
